import { render, staticRenderFns } from "./flight-info.vue?vue&type=template&id=130a6c72&scoped=true&"
import script from "./flight-info.vue?vue&type=script&lang=js&"
export * from "./flight-info.vue?vue&type=script&lang=js&"
import style0 from "./flight-info.vue?vue&type=style&index=0&id=130a6c72&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130a6c72",
  null
  
)

export default component.exports